import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import './Bullet.scss';
const Bullet = ({ isActive = false }) => {
    return _jsx("span", { className: classNames("bullet", { "bullet-active": isActive }) });
};
export default Bullet;
